<template>
  <div>
    <div class="top_logo w">
      <!-- <img src="../assets/login_logo.png" alt=""> -->
      <img style="height: 48px;" :src="imgPrefix + findTopBar.logoColor" alt="" />
    </div>
    <div class="login">
      <div class="content">
        <!-- <div>
          <img class="login_logo" src="../assets/login_logo.png" alt="" />
        </div> -->
        <div style="display: flex;">
          <!-- <img src="../assets/login.png" alt="" /> -->
          <div class="form" style="width: 488px;height: 334px;">
            <h2>系统登录</h2>
            <div>
              <a-input v-model="form.account" placeholder="账号" style="margin-bottom: 20px;" />
              <a-input-password v-model="form.pwMD5" placeholder="密码" />
            </div>
            <a-button type="primary" style="margin-top: 50px;width: 100%;" @click="login">登录</a-button>
          </div>
        </div>
      </div>
      <div class="desc">Copyright O 2022-2023 联奕科技 All Rights Reserved. </div>
    </div>
  </div>
</template>

<script>
import { tempLogin, login,findTopBarApi } from '../api/index'
import md5 from "js-md5";
import hexSha1 from 'hex-sha1';
import { JSEncrypt } from "jsencrypt";
import imgPrefix from "../../utils/imgPrefix";

export default {
  data() {
    return {
      form: {},
      imgPrefix,
      findTopBar:{},
    };
  },
  created() {
    // 获取顶部栏基本信息
    findTopBarApi().then((res) => {
      // console.log(res);
      this.findTopBar = res;
      document.title = res.sysName;
      // 改变主题颜色
      const bodyStyle = document.getElementsByTagName("body")[0].style;
      bodyStyle.setProperty("--themeColor", res.topicColor);
      // 改变网站图标
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.imgPrefix + res.webInco;
      document.getElementsByTagName("head")[0].appendChild(link);
      sessionStorage.setItem("findTopBar", JSON.stringify(res));
    });
  },
  methods: {
    // 登录
    login() {
      // let dto = Object.assign({}, this.form);
      // dto.pwMD5 = md5(this.form.pwMD5);
      // tempLogin(dto).then(res => {
      //   sessionStorage.setItem('ly-portal-affairs-ui-userLogin',res.portalManageAccessToken);
      //   this.$router.push('/');

      // }).catch(err => {
      //   this.$message.error(err.message)
      // })

      const pubKey =
        'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJ8DUCb0CEFATRWU8BtBL42RvsdFBcpxYNfsg0P1f7Rd1qKLtqLSBBVGrJu148CdCAkxwKOsjvj5D4eMeDQCd18CAwEAAQ==';
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(pubKey);
      const username = this.form.account.trim();
      const encryptPassword = encrypt.encrypt(this.form.pwMD5); // password为需要加密的字段
      const timestamp = new Date().getTime();
      const arr = [
        `username=${username}`,
        `password=${encryptPassword}`,
        `timestamp=${timestamp}`,
      ];
      const digest = hexSha1(arr.join(','));
      let dto = {
        encryptTransfer: 'true',
        timestamp,
        username,
        password: encryptPassword,
        digest,
      }
      let formdata = new FormData();
      formdata.append("encryptTransfer", true);
      formdata.append("timestamp", timestamp);
      formdata.append("username", username);
      formdata.append("password", encryptPassword);
      formdata.append("digest", digest);
      formdata.append("phoneNum", '');
      formdata.append("smsCode", '');
      login(formdata).then(res => {
          console.log(res,'----------');
          // sessionStorage.setItem('ly-portal-affairs-ui-userLogin', res.portalManageAccessToken);
          // this.$router.push('/');
        })
        .catch(res => {
          console.log(res,'*********');
          global.userId = res.data.userId;
          global.tokenId = res.data.tokenId;
          global.orgId = res.data.orgId;
          sessionStorage.setItem("ly-portal-affairs-ui-userLogin", JSON.stringify(res.data));
          sessionStorage.setItem('userId',res.data.userId);
          this.$message.success('登录成功！');
          setTimeout(() => {
            // console.log('-------------00');
            this.$router.push('/');
          }, 500);

          // this.$message.error(err.message)
        })

    },
  },
};
</script>

<style scoped lang="less">
.top_logo{
  height: 60px;
  line-height: 60px;
  text-align: left;
}
.login {
  // background: #dae7ff;
  background: url(../assets/login_banner.png) no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;

  .login_logo {
    margin-bottom: 25px;
    text-align: left;
  }
  .content {
    // display: flex;
    // flex-direction: column;
    .form {
      background: #fff;
      padding: 16px 4rem;

      h2 {
        // margin-top: 3rem;
        // margin-bottom: 4rem;
        margin-top: 16px;
        margin-bottom: 26px;
        text-align: left;
      }
    }
  }

  .desc {
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translate(-50%);
    color: #6B87BA;
    font-size: 12px;
  }
}
/deep/.ant-input,.ant-btn-primary{
  height: 36px;
}
</style>
